import script from "./TcSkeleton.vue.ts?vue&type=script&setup=true&lang=ts!=!../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./TcSkeleton.vue?vue&type=script&setup=true&lang=ts"
export * from "./TcSkeleton.vue.ts?vue&type=script&setup=true&lang=ts!=!../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./TcSkeleton.vue?vue&type=script&setup=true&lang=ts"

import "./TcSkeleton.vue.scss?vue&type=style&index=0&id=5e90f03e&lang=scss!=!../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./TcSkeleton.vue?vue&type=style&index=0&id=5e90f03e&lang=scss"

const __exports__ = script;

export default __exports__